import { CommentForm } from "@modules/sessionBlock/exercises/components/commentForm"
import { ScoreForm } from "@modules/sessionBlock/exercises/components/scoreForm"
import { Exercise } from "@modules/sessionBlock/exercises/exerciseTypes"
import { ParentSessionOrigin } from "@modules/sessionBlock/exercises/sessionTypes"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"

export const useScoreCommentFormSidebar = (
  exercise: Exercise,
  parentSessionOrigin: ParentSessionOrigin,
  refreshSession?: () => void,
) => {
  const { sidebarNavigateTo, sidebarNavigateBack } = useSidebar()

  const hideForm = () => {
    refreshSession && refreshSession()
    sidebarNavigateBack()
  }

  const navigateToScoreForm = (args?: SidebarNavigatorParams) => {
    document.getElementById("sidebar-content")?.scrollTo({ top: 0 })

    sidebarNavigateTo({
      content: <ScoreForm exercise={exercise} parentSessionOrigin={parentSessionOrigin} hideScoreForm={hideForm} />,
      ...args,
    })
  }

  const navigateToCommentForm = (args?: SidebarNavigatorParams) => {
    document.getElementById("sidebar-content")?.scrollTo({ top: 0 })

    sidebarNavigateTo({
      content: <CommentForm exercise={exercise} parentSessionOrigin={parentSessionOrigin} hideCommentForm={hideForm} />,
      ...args,
    })
  }

  return {
    navigateToScoreForm,
    navigateToCommentForm,
  }
}
